import { loadRuntimeConfig } from '@/app/config/runtimeConfig';
import { initI18n, normalizeLanguage } from '@/shared/i18n';
import { usePrefsStore } from '@/entities/preferences/model/prefsStore';
import { useAuthStore } from '@/entities/session/model/authStore';
import { applyPrefs } from '@/entities/preferences/lib/applyPrefs';
import { addBreadcrumb, installGlobalErrorLogging, setClientLogContext } from '@/shared/lib/logging/clientLog';
import { useTabsStore } from '@/features/shell/tabs/tabsStore';

/** Sıralı açılış: runtime config → i18n (cache dili) → oturum geri yükleme → sunucu tercihleri. */
export async function bootstrap() {
  /*
   * Hata dinleyicileri EN BAŞTA: açılışın kendisi patlarsa (runtime config, i18n,
   * oturum geri yükleme) o hata da kayda girsin — bugüne kadar beyaz ekranla
   * karşılaşan kullanıcının elinde hiçbir kayıt kalmıyordu.
   */
  installGlobalErrorLogging();
  await loadRuntimeConfig();
  const prefs = usePrefsStore.getState().prefs;
  applyPrefs(prefs);
  await initI18n(normalizeLanguage(prefs.language));
  await useAuthStore.getState().bootstrap();
  const user = useAuthStore.getState().user;
  setClientLogContext({ userCode: user?.userCode ?? null, version: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev' });

  /*
   * Kayıtlara "kim" ve "nerede" bilgisi CANLI bağlanır.
   *
   * Bağlam yalnızca açılışta kurulsaydı, açılışta oturum kapalıysa (normal durum) tüm
   * hatalar kullanıcısız düşerdi; ekran bilgisi de hiç olmazdı. Hatanın kimin hangi
   * ekranındayken oluştuğu, Seq'te aranacak ilk iki alan.
   */
  useAuthStore.subscribe(
    (s) => s.user,
    (u) => setClientLogContext({ userCode: u?.userCode ?? null }),
  );
  let lastScreen: string | null = null;
  useTabsStore.subscribe((s) => {
    const active = s.tabs.find((t) => t.tabId === s.activeTabId);
    const caption = active ? active.caption : null;
    setClientLogContext({ screen: caption });
    // Ekran değişimi hatadan önceki adımların en değerlisi: "hangi ekranda patladı"
    // sorusunu yığın izi değil bu satır yanıtlıyor.
    if (caption && caption !== lastScreen) addBreadcrumb('ekran', caption);
    lastScreen = caption;
  });
  if (user) {
    await usePrefsStore.getState().hydrateFromServer(user.userId);
    await initI18n(normalizeLanguage(usePrefsStore.getState().prefs.language));
  }
}
